import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function NotificationPermissionBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if we've already asked for permission
    const hasAsked = localStorage.getItem('notificationPermissionAsked');
    
    if (!hasAsked && 'Notification' in window) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = async () => {
    try {
      // Add a small delay before requesting permission to ensure the click event is fully processed
      await new Promise(resolve => setTimeout(resolve, 100));
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        // Permission granted successfully
      }
    } catch (error) {
      console.error('Error requesting notification permission:', error);
    } finally {
      // Always mark that we've asked for permission and hide the banner
      localStorage.setItem('notificationPermissionAsked', 'true');
      setShowBanner(false);
    }
  };

  const handleDecline = () => {
    // Mark that we've asked for permission
    localStorage.setItem('notificationPermissionAsked', 'true');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-accent border-b border-primary z-[100]">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center">
          <p className="text-sm text-gray-800">
            Would you like to receive desktop notifications for updates?
          </p>
        </div>
        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            size="sm"
            onClick={handleAccept}
            className="bg-primary text-white hover:bg-primaryHover"
          >
            Accept
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleDecline}
            className="text-gray-600 hover:text-gray-800"
          >
            Decline
          </Button>
          <button
            onClick={handleDecline}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
} 